(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const video = document.getElementById('hero-video');
  
  if (video) {
    // Show video once it can play
    video.addEventListener('loadeddata', function() {
      video.classList.add('loaded');
    });

    video.addEventListener('canplaythrough', function() {
      video.classList.add('loaded');
    });

    // Fallback: If video doesn't load within 2 seconds, keep showing image
    setTimeout(function() {
      if (video.readyState >= 2) {
        video.classList.add('loaded');
      }
    }, 2000);

    // Attempt to play video
    video.play().catch(function(error) {
      console.log('Video autoplay prevented:', error);
      // Keep image visible if video can't play
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
  function initNewArrivalsSwiper() {
    if (typeof Swiper === 'undefined') {
      // If Swiper isn't loaded yet, try again in a moment
      setTimeout(initNewArrivalsSwiper, 50);
      return;
    }

    const newArrivalsSwiper = new Swiper('.new-arrivals-swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      grabCursor: true,
      navigation: {
        nextEl: '.new-arrivals-next',
        prevEl: '.new-arrivals-prev',
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 24,
        }
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewArrivalsSwiper);
  } else {
    initNewArrivalsSwiper();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  function initCategorySwiper() {
    if (typeof Swiper === 'undefined') {
      // If Swiper isn't loaded yet, try again in a moment
      setTimeout(initCategorySwiper, 50);
      return;
    }

    const categorySwiper = new Swiper('.category-swiper', {
      slidesPerView: 1,
      spaceBetween: 12,
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: '.category-next',
        prevEl: '.category-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 12,
        }
      },
      on: {
        init: function() {
          // Set slide width for larger screens
          if (window.innerWidth >= 1024) {
            const slides = document.querySelectorAll('.category-swiper .swiper-slide');
            slides.forEach(slide => {
              slide.style.width = '480px';
            });
          }
        },
        resize: function() {
          // Update slide width on resize
          if (window.innerWidth >= 1024) {
            const slides = document.querySelectorAll('.category-swiper .swiper-slide');
            slides.forEach(slide => {
              slide.style.width = '480px';
            });
          } else {
            const slides = document.querySelectorAll('.category-swiper .swiper-slide');
            slides.forEach(slide => {
              slide.style.width = '';
            });
          }
        }
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategorySwiper);
  } else {
    initCategorySwiper();
  }

  } catch(e) { console.error(e); }
})();
})();
